import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Switch, Typography, Grid } from '@material-ui/core';

const useStyles = makeStyles({
    root: {
        background: '#212121'
    },
    TypographyRoot: {
        marginRight: 10
    },
    switchBase: {
        color: '#bdbdbd',
        '&$checked': {
            transform: 'translateX(16px)',
            color: '#4CAF50',
            '& + $track': {
                backgroundColor: '#3E8040',
                opacity: 1,
                border: 'none',
            },
        },
    },
    switchBase2: {
        color: '#bdbdbd',
        '&$checked': {
            transform: 'translateX(16px)',
            color: '#ffee58',
            '& + $track': {
                backgroundColor: '#B7A931',
                opacity: 1,
                border: 'none',
            },
        },
    },
    checked: {},
    track: {},
    swithColorPrimary: {
        color: 'yellow'
    }
});


export const ItemFilters = (props) => {
    const classes = useStyles();
    const { label, value, selected, isDisabled = false} = props;

    const isSelected=selected.includes(value.toString()) || selected.includes(value)
    const handleChange = e => {
        if(e.target.checked){
            props.setItem(value)
        }else{
            props.setItem(value, true)
        }
    }

    return (
        <Grid container alignItems="center">
            <Grid item xs={2}>
                <Switch
                    checked={isSelected}
                    name={label}
                    value={value}
                    onChange={handleChange}
                    classes={{ switchBase: classes.switchBase, checked: classes.checked, track: classes.track }}
                    disabled={isDisabled}
                />
            </Grid>
            <Grid item xs={10} >
                <Typography className={classes.TypographyRoot} >{label}</Typography>
            </Grid>
        </Grid>
    );
};